var React = require('react');

function IconFacebookWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M14218.522 62.147c0-3927-3184-7111-7111-7111s-7111 3184-7111 7111c0 3549 2600 6491 5999.999 7025v-4969h-1806v-2056h1806v-1567c0-1782 1062.001-2767 2686.001-2767 778 0 1592 139 1592 139v1750h-897c-883 0-1159 548-1159 1111v1334h1972l-315 2056h-1657v4969c3400-533 6000-3475 6000-7025z"}));
}

IconFacebookWhiteInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 14222 44.728"};

module.exports = IconFacebookWhiteInline;

IconFacebookWhiteInline.default = IconFacebookWhiteInline;
